import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TermsMaintenanceService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get Terms
   * @param Obj
   */
  getTerms(Obj: any): Observable<any>{
    const url = `${environment.authUrl}/terms/getTerms`;
    return this.http.post(url,Obj);
  }

  /**
   * update Terms
   * @param Obj
   */
  updateTerms(Obj: any): Observable<any>{
    const url = `${environment.authUrl}/terms/updateTerms`;
    return this.http.post(url,Obj);
  }

  updateTermsFlag(createUser: string, id: string, language: string): Observable<any> {
    return this.http.post<any>(`${environment.authUrl}/terms/updateTermsFlag`, {
      termsContent: "",
      termsTitle: 'laasTerms',
      uuid: id,
      createUser: createUser,
      language: language
    })
}
}


